import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  optionCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(3),
    border: `1px solid ${theme.palette.secondary.superLight}`,
    borderRadius: theme.shape.borderRadius,
    cursor: 'pointer',
    transition: 'border-color 0.2s, box-shadow 0.2s',
    flex: 1,
    '&:hover': {
      borderColor: theme.palette.primary.main,
      boxShadow: theme.shadows[2],
    },
  },
  optionsRow: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  optionIcon: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
  },
  optionLabel: {
    fontWeight: 600,
    color: theme.palette.primary.main,
    textAlign: 'center',
  },
  optionDescription: {
    color: theme.palette.secondary.main,
    textAlign: 'center',
    fontSize: theme.typography.pxToRem(12),
  },
}))

export default useStyles
